import { isValidCmsPage } from '~~/helpers/routes/getPageInformation';
import type { PublishedCmsPages } from '~~/helpers/cms/publishedCmsPages';
import type { HelpMenuItemData } from '~~/types/cms/HelpMenuItemData';

const isExternalMenuItemSlug = (menuItemSlug: string): boolean => menuItemSlug.startsWith('http');

type FilterPublishedMenuItemsParams = {
  menuItems: HelpMenuItemData[],
  languageAndCountry: string,
  publishedPages: PublishedCmsPages,
};

/**
 * basic-page-navigation-*.json menu entries mostly point at CMS-authored pages via a
 * leading/trailing-slash slug (e.g. "/premium-guarantee/"), reusing the same isValidCmsPage
 * check DynamicCmsPage/useIsPage use, so a page hidden via useDynamicPublishedCmsPages also
 * disappears from the menu. A few entries are plain external links (e.g. Microsoft Forms URLs)
 * that aren't tracked in published-pages.json at all — those always stay visible.
 */
export const filterPublishedMenuItems = ({
  menuItems,
  languageAndCountry,
  publishedPages,
}: FilterPublishedMenuItemsParams): HelpMenuItemData[] =>
  menuItems.filter(({ menuItemSlug }) =>
    isExternalMenuItemSlug(menuItemSlug) ||
    isValidCmsPage({ slug: menuItemSlug.replace(/^\/+|\/+$/g, ''), languageAndCountry, publishedPages }));
